import React from 'react'
import { useTranslation } from 'react-i18next'
import { Drawer, Classes, AnchorButton, Intent, Position } from '@blueprintjs/core'

const BPDrawer = ({
  title, children, footer, onClose, position, show, size, onAccept, removeFooter, icon, confirmButtonText, isCloseButtonShown = true, showChange = true,
  canOutsideClickClose, canEscapeKeyClose, hideFooterCloseButton, closeButtonText, leftAlignFooter, hasBackdrop = true, usePortal = true, className
}) => {
  const { t } = useTranslation()

  const handleOnClose = () => {
    onClose && onClose()
  }

  const handleOnAccept = () => {
    onAccept && onAccept()
  }

  const DrawerFooter = () => {
    return (
      !removeFooter && (footer ||
        <div className={Classes.DRAWER_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS} style={{ justifyContent: leftAlignFooter ? 'flex-start' : 'flex-end' }}>
            {!hideFooterCloseButton &&
              <AnchorButton intent={Intent.DANGER} onClick={handleOnClose}>{closeButtonText || t('close')}</AnchorButton>}
            {showChange &&
              <AnchorButton
                intent={Intent.PRIMARY}
                onClick={handleOnAccept}
              >
                {confirmButtonText || t('save_changes')}
              </AnchorButton>}
          </div>
        </div>
      )
    )
  }

  return (
    <>
      {show &&
        <Drawer
          className={`bluePrintDrawer ${className}`}
          autoFocus
          enforceFocus
          isOpen={show}
          usePortal={usePortal}
          hasBackdrop={hasBackdrop}
          icon={icon || <img src='img/logo/ROCHE_LOGO_22px_RGB_DIGITAL.png' alt='Roche Logo' />}
          size={size}
          onClose={handleOnClose}
          onAccept={handleOnAccept}
          title={title}
          position={position || Position.RIGHT}
          isCloseButtonShown={isCloseButtonShown}
          canOutsideClickClose={!!canOutsideClickClose}
          canEscapeKeyClose={!!canEscapeKeyClose}
        >
          <div className={Classes.DRAWER_BODY}>
            <div className={Classes.DIALOG_BODY}>
              {children}
            </div>
          </div>
          <DrawerFooter />
        </Drawer>}
    </>
  )
}

export default BPDrawer

// Drawer sizes = 50,60,90 %
// Drawer position = Position.TOP, Position.RIGHT, Position.BOTTOM, Position.LEFT
